export const GET_LEDGER_FILTERS = 'GET_LEDGER_FILTERS'
export const GET_LEDGER_FILTERS_FAILED = 'GET_LEDGER_FILTERS_FAILED'
export const GET_LEDGER_FILTERS_SUCCEEDED = 'GET_LEDGER_FILTERS_SUCCEEDED'

export const RESET_LEDGER_FILTERS = 'RESET_LEDGER_FILTERS'
